import { render, staticRenderFns } from "./pembayaran.vue?vue&type=template&id=14951030"
import script from "./pembayaran.vue?vue&type=script&lang=js"
export * from "./pembayaran.vue?vue&type=script&lang=js"
import style0 from "./pembayaran.vue?vue&type=style&index=0&id=14951030&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports